
import React from "react";
import moment from "moment";
import { message } from "antd";
import PaginationBase from "../../../common/base/PaginationBase";
import global from "../../../common/utility/global";
import auth from "../../../common/utility/auth";
import dialog from "../../../common/utility/dialog";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import { SOLES, DOLARES_AMERICANOS } from "../../../common/types/monedaType";
import { OTROS, RECIBO_POR_HONORARIOS } from '../../../common/types/tipoComprobanteType';
import { SERVICIO } from '../../../common/types/tipoProductoType';

import tipoComprobanteService from "../../../service/administracion/tipoComprobanteService";
import honorarioService from "../../../service/logistica/honorario";
import monedaService from "../../../service/administracion/monedaService";
import tipoCambioDiarioService from "../../../service/administracion/tipoCambioDiarioService";
import establecimientoService from "../../../service/administracion/establecimientoService";
import almacenService from "../../../service/administracion/almacenService";
import productoService from "../../../service/administracion/productoService";
import proyectoService from '../../../service/administracion/proyectoService';
import entidadService from '../../../service/administracion/entidadService';
import padronReducidoService from "../../../service/integracion/padronReducidoService";
import proveedorService from "../../../service/administracion/proveedorService";

import { CONTADO, CREDITO } from '../../../common/types/formaPagoType';
import { RUC } from '../../../common/types/tipoDocumentoType';


import Header from "../../../components/Header";
import Filters from "./Filters";
import ResultList from "./ResultList";
import FormModal from "./FormModal";
import ViewModal from "./ViewModal";

import BuscarProductoModal from "./BuscarProductoModal";
import EditarNombreProductoModal from "./EditarNombreProductoModal";


export default class Index extends PaginationBase {
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      loadingSource: true,
      loadingExcel: false,
      loadingPdf: false,
      loadingPrint: false,
      searchProductVisible: false,
      importarOCVisible: false,
      isPendiente: false,
      isPendienteSi: true,
      loadingVincular: false,
      filter: {
        idEntidad: 0,
        idEstado: 0,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: "",
        documento: "",
        idProyecto: 0,
        ...FILTER,
      },
      editarNombreProductoFormValues: {
        id: "",
        nombre: "",
      },
      searchProductFormValues: {
        nombre: "",
        dataSource: [],
        selectedRowKeys: [],
      },
      direcciones: [],
      proveedores: [],
      monedas: [],
      establecimientos: [],
      tiposComprobante: [],
      proveedoresAutoComplete: [],
      estados: [
        { id: 1, nombre: "REGISTRADO" },
        { id: 2, nombre: "APROBADO" },
        { id: 3, nombre: "ANULADO" }
      ],
      proyectos: [],
      pagination: PAGINATION,
      visible: false,
      formValues: this.fetchEmptyFormValues(),
      viewVisible: false,
      viewFormValues: {},
      viewVincular: {},
    };
  }

  fetchEmptyFormValues = () => {
    return {
      id: 0,
      idEntidad: 0,
      idTipoComprobante: RECIBO_POR_HONORARIOS.ID,
      idMoneda: SOLES,
      idEstablecimiento: 0,
      idEstablecimientoEntidad: 0,
      idAlmacen: 0,
      idProyecto: 0,
      fechaStr: global.fetchCurrentDateStr(),
      fechaRecepcionStr: global.fetchCurrentDateStr(),
      serie: "",
      documento: "",
      idFormaPago: CONTADO,
      idUsuarioRegistro: auth.user().id,
      tipoCambio: 0,
      observacion: "",
      listaHonorarioDetalle: [],
      listaHonorarioReferencia: [],
      /*********************/
      sumaTotalDetalle: 0,
      sumaImporteDescuento: 0,
      sumaSubTotal: 0,
      sumaIgv: 0,
      sumaIsc: 0,
      sumaTotal: 0,
      porcentajeDetraccion: 0,
      importeDetraccion: 0,
      totalDetraccion: 0,
      porcentajePercepcion: 0,
      importePercepcion: 0,
      totalPercepcion: 0,
      almacenLoading: false,
      proveedorLoading: false,
      activeKey: "1",
      documentoCliente: "",
      monedas: [],
      establecimientos: [],
      proveedores: [],
      direcciones: [],
      detalleProductos: [],
      tiposComprobante: [],
      // conceptos: [],
      proyectos: [],
    };
  };

  handleSearchAutocomplete = (value) => {
    const result = this.state.proveedores
      .filter((item) => {
        return item.nombre.toUpperCase().match(value.toUpperCase());
      })
      .slice(0, 75);
    this.setState({ proveedoresAutoComplete: result });
  };

  handleChangeAutocomplete = (value) => {
    this.setState({
      filter: {
        ...this.state.filter,
        idEntidad: value.key,
      },
    });
  };

  handleClearAutocomplete = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        idEntidad: 0,
        idTipoComprobante: RECIBO_POR_HONORARIOS.ID,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: "",
        documento: "",
        idProyecto: 0,
      },
    });
  };

  handleKeyUpInput = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      const filter = { ...this.state.filter, ...FILTER };
      this._handlePagination(filter);
    }
  };

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    if(property=='idEstado'){
      var estados = this.state.estados;
      estados[0] = { id: -1, nombre: "TODOS" };
  }
    this.setState({ filter });
  };

  handleClearFilters = async () => {
    var filter = {
      serie: "",
      documento: "",
      idEstado: 0,
      idEntidad: 0,
      idTipoComprobante: 0,
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
      ...FILTER,
    };
    var estados = this.state.estados;
    estados[0] = { id: -1, nombre: "Seleccionar Estado" };
    this.setState({ filter });
    this._handlePagination(filter);
  };

  handleChangeTab = (key, onSetFieldsValue) => {
    if (key == "2") {
      onSetFieldsValue({
        flagReferencia: true,
      });
    }
    if (key == "3") { // Cuotas
      onSetFieldsValue({
        flagCuota: true
      })
    }

    if (key == "4") { // Metodo de Pago
      onSetFieldsValue({
        flagMetodoPago: true
      })
    }

    this.setState({
      formValues: {
        ...this.state.formValues,
        activeKey: key,
      },
    });
  };

  handleNew = async () => {
    debugger
    this.setState({ loadingNew: true });
    var formValues = this.fetchEmptyFormValues();
    formValues.monedas = this.state.monedas;
    formValues.tipoCambio = 0;
    formValues.establecimientos = this.state.establecimientos;
    formValues.proveedores = this.state.proveedores;
    formValues.cuentas = this.state.cuentas;
    formValues.proyectos = this.state.proyectos;
    formValues.tiposComprobante = this.state.tiposComprobante;
    this.setState({
      loadingNew: false,
      visible: true,
      listaCuentas: this.state.cuentas,
      formValues,
    });
  };

  fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
    const filter = (tiposCambioDiario
      ? tiposCambioDiario
      : this.state.tiposCambioDiario
    ).filter((m) => m.idMoneda === idMoneda);
    if (filter.length > 0) return parseFloat(filter[0].HonorarioSunat).toFixed(3);
    else return "0.000";
  };

  handleChangeForm = async (property, value, form) => {

    if (property === "fechaStr") {
      const fecha = moment(value, "DD/MM/YYYY");
      const fechaVencimiento = moment(
        form.getFieldValue("fechaVencimientoStr"),
        "DD/MM/YYYY"
      );
      const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
        value
      );

      form.setFieldsValue({
        tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }

    if (property === "idMoneda") {
      const listasPrecio = this.state.listasPrecio.filter(
        (m) => m.idMoneda === value
      );
      this.setState({
        formValues: {
          ...this.state.formValues,
          idListaPrecio: undefined,
          listasPrecio: listasPrecio ? listasPrecio : [],
        },
      });
    }

    if (property === "idEntidad") {

      debugger
      const direcciones = await establecimientoService.listarPorIdEntidad(
        value
      );
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            direcciones: direcciones ? direcciones : [],
          },
        },
        () => {
          form.setFieldsValue({
            idEstablecimientoEntidad: {
              key: direcciones.length > 0 ? direcciones[0].id : undefined,
            },
          });
        }
      );
    }


    if (property === "direcciones-clear") {
      this.setState({
        formValues: {
          ...this.state.formValues,
          idEntidad: undefined,
          idEstablecimientoEntidad: undefined,
          documentoProveedor: "",
          direcciones: [],
        },
      });
    }

    if (property === "idEstablecimiento") {
      this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
      const almacenes = await almacenService.listarPorIdEstablecimiento(value);
      this.setState({
        formValues: {
          ...this.state.formValues,
          almacenLoading: false,
          almacenes: almacenes ? almacenes : [],
        }
      });
      form.setFieldsValue({
        idAlmacen: undefined,
        idTipoAlmacen: undefined
      });
    }
  };



  handleAgregarItem = (onSetFieldsValue, onGetFieldValue) => {

    var listaComprobanteDetalle = this.state.formValues.listaHonorarioDetalle;

    var item = {
      identifier: global.fetchUniqueCode(),
      idProducto: 1,
      idTipoProducto: 2, //Servicio
      codigo: null,
      nombre: 'Item ' + this.state.formValues.listaHonorarioDetalle.length,
      nombreUnidadMedida: 'UNIDAD (SERVICIOS)',
      flagAfecto: true,
      flagGratuito: false,
      flagISC: false,
      flagExonerado: false,
      isc: 0,
      precioUnitario: 0,
      precioNuevo: 0,
      cantidad: 0,
      totalDetalle: 0,
      numeroLote: '',
      porcentajeDescuento: 0,
      importeDescuento: 0,
      subTotal: 0,
      igv: 0,
      total: 0,
    };
    listaComprobanteDetalle.push(item);

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaHonorarioDetalle: listaComprobanteDetalle
      },
    });


  };

  handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
    this.setState({ onSetFieldsValue, onGetFieldValue },
      () => {
        if (this.state.formValues.activeKey === "1")
          this.handleOpenSearchProductModal();

        const newLocal = "2";
        if (this.state.formValues.activeKey === newLocal)
          this.handleAddReferencia();
      }
    );
  };

  handleOpenSearchProductModal = async () => {

    var tipoActividad = this.state.formValues.idTipo;
    var productos = await productoService.listar();
    var productos_filter = tipoActividad == 1 ? productos.filter(m => m.idTipoProducto != 1) : productos.filter(m => m.idTipoProducto === 1);

    var filter = {
      idAlmacen: 0,
      idListaPrecio: 0,
      idMoneda: 1,
      IdSistema: 2
    }
    var response = await productoService.Sinstock(filter);
    var productos_filter = response.productos.filter(m => m.idTipoProducto == SERVICIO && m.flagRenta == true)

    if (productos_filter.length == 0) {
      dialog.info("Tiene que agregar un servicio de tipo renta.");
      return false;
    }

    this.setState({
      searchProductVisible: true,
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        dataSource: productos_filter,
        selectedRowKeys: this.state.formValues.listaHonorarioDetalle.map(function (v) {
          return v.idProducto;
        })
      },
      productos
    });
  };

  handleAddReferencia = () => {
    var listaHonorarioReferencia = this.state.formValues.listaHonorarioReferencia;

    listaHonorarioReferencia.push({
      identifier: global.fetchUniqueCode(),
      idReferencia: 0,
      idReferenciaOrigen: 0,
      idTipoComprobante: 0,
      serie: "",
      documento: "",
      flagInterno: false,
    });

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaHonorarioReferencia: listaHonorarioReferencia,
        tiposComprobanteAll: this.state.tiposComprobante,
      },
    });
  };


  handleChangeProductoModal = (value) => {
    if (value != null && value != undefined && value != '') {
      const dataSource = this.state.productos.filter(item => {
        return (item.codigoReferencia + ' - ' + item.nombre)
          .toUpperCase()
          .match(value.toUpperCase());
      });

      this.setState({
        searchProductFormValues: {
          ...this.state.searchProductFormValues,
          dataSource: dataSource
        }
      });
    } else {
      this.setState({
        searchProductFormValues: {
          ...this.state.searchProductFormValues,
          dataSource: this.state.productos
        }
      });
    }
  };




  handleSelectProduct = (selected, rows) => {
    var listaComprobanteDetalle = this.state.formValues.listaHonorarioDetalle;

    if (rows.length > 1) {
      dialog.info("No se puede agregar mas 2 detalles.");
      return false;
    }
    rows.forEach(row => {
      var filter = this.state.formValues.listaHonorarioDetalle.filter(m => { return m.idProducto === row.id; });
      if (filter.length === 0) {

        var item = {
          identifier: global.fetchUniqueCode(),
          idProducto: row.id,
          idTipoProducto: row.idTipoProducto,
          codigo: row.codigoReferencia,
          nombre: row.nombre,
          nombreUnidadMedida: row.nombreUnidadMedida,
          flagAfecto: row.flagIGVAfecto,
          flagGratuito: row.flagGratuito,
          flagISC: row.flagISC,
          flagExonerado: row.flagExonerado,
          retencion: 0,
          precioUnitario: 0,
          precioNuevo: 0,
          precioUnitarioSinIGV: 0,
          cantidad: 1,
          totalDetalle: 0,
          numeroLote: '',
          porcentajeDescuento: 0,
          importeDescuento: 0,
          subTotal: 0,
          igv: 0,
          total: 0,
        };
        listaComprobanteDetalle.push(item);
      }
    });

    listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaHonorarioDetalle: listaComprobanteDetalle
      },
      searchProductFormValues: {
        ...this.state.searchProductFormValues,
        selectedRowKeys: selected
      }
    });
  };


  handleSave = async (item, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response;
      if (item.id === 0) response = await honorarioService.registrar(item);
      else response = await honorarioService.modificar(item);
      if (response.status === 200) {
        form.resetFields();
        this.setState({ visible: false });
        message.success((item.id === 0 ? "Registrado" : "Modificado") + " correctamente.");
        this._handlePagination(this.state.filter);
        return;
      }
      if (response.status === 400) {
        dialog.warning(<ul>{response.data.messages.map((item) => (<li>{item}</li>))}</ul>);
        return;
      }
      dialog.error("Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.");
    });
  };

  handleView = async (item) => {
    this.setState({ loadingVer: true });
    var response = await honorarioService.obtenerPorId(item.id);
    if (response !== undefined) {
      this.setState({
        loadingVer: false,
        viewVisible: true,
        viewFormValues: response,
      });
    }
  };

  handleEdit = async (item) => {
    this.setState({ loadingEdit: true });
    const response = await honorarioService.obtenerPorId(item.id);
    if (response === undefined) {
      this.setState({ loadingEdit: false });
      dialog.error("Ocurrió un error mientras se obtenia los datos.");
      return;
    }
    debugger

    var formValues = {
      id: response.id,
      idTipoComprobante: response.idTipoComprobante,
      idEntidad: response.idEntidad,
      documentoEntidad: response.numeroDocumentoEntidad,
      idEstablecimientoEntidad: response.idEstablecimientoEntidad,
      idMoneda: response.idMoneda,
      idProyecto: response.idProyecto,
      idEstablecimiento: response.idEstablecimiento,
      idUsuarioRegistro: auth.user().id,
      serie: response.serie,
      documento: response.documento,
      fechaStr: response.fechaStr,
      fechaRecepcionStr: response.fechaRecepcionStr,
      fechaDocumentoStr: response.fechaDocumentoStr,
      tipoCambio: response.tipoCambio,
      observacion: response.observacion,
      listaHonorarioDetalle: [],
      listaHonorarioReferencia: [],
      monedas: [],
      /*********************/
      activeKey: "1",
      sumaTotalDetalle: response.totalDetalle,
      sumaSubTotal: response.importe,
      sumaIgv: response.retencion,
      sumaTotal: response.total,
      almacenLoading: false,
      clienteLoading: false,
      detalleProductos: [],
    };

    response.detalles.forEach((element) => {
      const identifier = global.fetchUniqueCode();
      formValues.listaHonorarioDetalle.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        codigo: element.codigoReferencia,
        nombre: element.nombre,
        nombreUnidadMedida: element.nombreUnidadMedida,
        flagRenta: element.flagRenta,
        precioUnitario: element.precioUnitario,
        precioUnitarioSinIGV: element.precioUnitarioSinIGV,
        cantidad: element.cantidad,
        totalDetalle: element.totalDetalle,
        importe: element.importe,
        retencion: element.retencion,
        total: element.total,
      });

      formValues.detalleProductos.push({
        identifier: identifier,
        idProducto: element.idProducto,
        idTipoProducto: element.idTipoProducto,
        nombre: element.nombre,
        cantidad: element.cantidad,
        precioUnitario: element.precioUnitario,
        flagRenta: element.flagRenta,
        importe: element.importe,
        retencion: element.retencion,
        total: element.total,
      });
    });

    response.referencias.forEach((element) => {
      formValues.listaHonorarioReferencia.push({
        identifier: global.fetchUniqueCode(),
        flagInterno: element.flagInterno,
        idReferenciaOrigen: element.idReferenciaOrigen,
        idReferencia: element.idReferencia,
        idTipoComprobante: element.idTipoComprobante,
        serie: element.serie,
        documento: element.documento,
      });
    });


    const proveedorFiltered = this.state.proveedores.filter(
      (m) => m.id === formValues.idEntidad
    );

    const idEntidad = proveedorFiltered.length > 0 ? proveedorFiltered[0].idEntidad : 0;
    const direcciones = await establecimientoService.listarPorIdEntidad(
      idEntidad
    );

    formValues.monedas = this.state.monedas ? this.state.monedas : [];
    formValues.cuentas = this.state.cuentas;
    formValues.proyectos = this.state.proyectos;
    formValues.establecimientos = this.state.establecimientos;
    formValues.vendedores = this.state.vendedores;
    formValues.proveedores = this.state.proveedores;
    formValues.direcciones = direcciones;
    formValues.tiposComprobante = this.state.tiposComprobante;

    this.setState({ loadingEdit: false, visible: true, formValues });
  };


  handleRemoverProducto = (row, form) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          listaHonorarioDetalle: this.state.formValues.listaHonorarioDetalle.filter(
            (m) => m.identifier !== row.identifier
          ),
        },
      },
      () => {
        var detalleProductos = form.getFieldValue("detalleProductos");
        form.setFieldsValue({
          detalleProductos: detalleProductos.filter(
            (m) => m.identifier !== row.identifier
          ),
        });
      }
    );
  };

  handleRemoverReferencia = (item) => {
    var listaHonorarioReferencia = this.state.formValues.listaHonorarioReferencia.filter((m) => m.identifier !== item.identifier);

    this.setState({
      formValues: {
        ...this.state.formValues,
        listaHonorarioReferencia: listaHonorarioReferencia,
      },
    });
  };

  handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
    var formValues = {
      id: row.identifier,
      nombre: onGetFieldValue(`arrNombre[${row.identifier}]`),
    };

    this.setState({
      editarNombreProductoVisible: true,
      editarNombreProductoFormValues: formValues,
      onSetFieldsValue,
      onGetFieldValue,
    });
  };

  handleSaveEditarNombreProducto = (values, form) => {
    form.resetFields();
    this.setState({ editarNombreProductoVisible: false });
    var detalleProductos = this.state.onGetFieldValue("detalleProductos");
    detalleProductos.forEach((item) => {
      if (item.identifier === values.id) {
        item.nombre = values.nombre;
        return;
      }
    });

    this.state.onSetFieldsValue({
      detalleProductos,
      [`arrNombre[${values.id}]`]: values.nombre,
    });
  };

  handleExportExcel = async () => {
    this.setState({ loadingExcel: true });
    var response = await honorarioService.excel(this.state.filter);
    this.setState({ loadingExcel: false });

    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Ingresos.xlsx");
  };

  handleExportPdf = async () => {
    this.setState({ loadingPdf: true });
    var response = await honorarioService.pdf(this.state.filter);
    this.setState({ loadingPdf: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Ingresos.pdf");
  };

  handleAnular = async (item) => {
    dialog.confirm(
      `¿Desea anular Honorario ${item.serie}-${item.documento}?`,
      async () => {
        var response = await honorarioService.anular({ id: item.id });

        if (response.status === 200) {
          dialog.success(
            `Honorario ${item.serie}-${item.documento} anulado correctamente.`
          );
          this._handlePagination(this.state.filter);
          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
      }
    );
  };

  handleAprobar = async (item) => {
    dialog.confirm(
      `¿Desea aprobar Honorario ${item.serie}-${item.documento} ?`,
      async () => {
        var response = await honorarioService.aprobar({ id: item.id });

        if (response.status === 200) {
          dialog.success(
            `Honorario ${item.serie}-${item.documento} aprobado correctamente.`
          );
          this._handlePagination(this.state.filter);
          return;
        }

        if (response.status === 400) {
          dialog.warning(
            <ul>
              {response.data.messages.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          );
          return;
        }

        dialog.error(
          "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
        );
      }
    );
  };



  handleBuscarProveedor = async (value, form) => {
    this.setState({
      formValues: { ...this.state.formValues, proveedorLoading: true },
    });

    //const response = await padronReducidoService.logistica_proveedor(value);

    var numberDocument = form.getFieldValue("documentoEntidad");
    if (numberDocument == "" || numberDocument == null || numberDocument == undefined) {
      dialog.warning(<ul>Ingrese documento valido</ul>);

      return;
    }

    var response = await padronReducidoService.obtenerProveedorRucApi(value);
    if (response.status === 400) {
      dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
      this.setState({ formValues: { ...this.state.formValues, proveedorLoading: false } });

      return;
    }

    if (response.status === 200) {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            proveedorLoading: false,
            direcciones: response.data.direcciones,
          },
        },
        () => {
          form.setFieldsValue({
            proveedores: response.data.proveedores,
            idEntidad:
              response.data.proveedores.length > 0
                ? { key: response.data.proveedores[0].id }
                : undefined,
            idEstablecimientoEntidad:
              response.data.direcciones.length > 0
                ? { key: response.data.direcciones[0].id }
                : undefined,
            direccionEntidad:
              response.data.direcciones.length > 0
                ? response.data.direcciones[0].direccion
                : ""
          });
        }
      );
    } else {
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            proveedorLoading: false,
            direcciones: [],
          },
        },
        () => {
          form.setFieldsValue({
            proveedores: [],
            idProveedor: undefined,
            idEstablecimientoEntidad: undefined,
          });
        }
      );
    }
  };



  handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
    var listaComprobanteDetalle = this.state.formValues.listaHonorarioDetalle;
    this.setState({
      onSetFieldsValue,
      onGetFieldValue,
    });

    var productos = await productoService.listarBarras(value);

    if (productos.length == 0) {
      message.warning('Por favor seleccione un scanner.');
      return;
    } else {

      const selections = this.state.searchProductFormValues.selectedRowKeys;

      var product_selected = productos[0].id;
      selections.push(product_selected);

      var dataItem = {
        codigoReferencia: productos[0].codigoReferencia,
        flagExonerado: productos[0].flagExonerado,
        flagICBPER: productos[0].flagICBPER,
        flagIGVAfecto: productos[0].flagIGVAfecto,
        flagISC: productos[0].flagISC,
        id: productos[0].id,
        idTipoProducto: productos[0].idTipoProducto,
        nombre: productos[0].nombre,
        nombreMarca: productos[0].nombreMarca,
        nombreTipoProducto: productos[0].nombreTipoProducto,
        nombreUnidadMedida: productos[0].nombreUnidadMedida,
      }


      //var listaComprobanteDetalle = this.state.formValues.listaHonorarioDetalle.filter((m) => m.idProducto !== product_selected);
      var productos_ = this.state.searchProductFormValues.dataSource;
      var productos_filter = productos_.push(dataItem);




      this.handleSelectProduct(selections, productos);

    }

  };

  async componentDidMount() {

    this._initPagination(this.state.filter, honorarioService.paginacion);
    const monedas = await monedaService.listar();
    const tiposComprobante = await tipoComprobanteService.listar();

    const establecimientos = await establecimientoService.principales();

    const proyectos = await proyectoService.listar();

    const proveedores = await proveedorService.listar();

    var proveedor_filter = proveedores.filter((m) => { return m.numeroDocumento.charAt(0) == "1" });


    this.setState({
      loadingSource: false,
      tiposComprobante: tiposComprobante ? tiposComprobante : [],
      monedas: monedas ? monedas : [],
      proveedores: proveedor_filter ? proveedor_filter : [],
      establecimientos: establecimientos ? establecimientos : [],
      proyectos: proyectos ? proyectos : [],
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Recibos Honorarios"
          onNew={this.handleNew}
          loadingNew={this.state.loadingSource}
          onSearch={() => this._handlePagination(this.state.filter)}
          onClearFilters={this.handleClearFilters}
        />

        <Filters
          filter={this.state.filter}
          proveedores={this.state.proveedores}
          estados={this.state.estados}
          onSearchAutocomplete={this.handleSearchAutocomplete}
          onChangeAutocomplete={this.handleChangeAutocomplete}
          onClearAutocomplete={this.handleClearAutocomplete}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
          proyectos={this.state.proyectos}

        />

        <ResultList
          pagination={this.state.pagination}
          loadingEdit={this.state.loadingEdit}
          loadingVincular={this.state.loadingVincular}
          loadingExcel={this.state.loadingExcel}
          loadingPdf={this.state.loadingPdf}
          onExportExcel={this.handleExportExcel}
          onExportPdf={this.handleExportPdf}
          onChange={this._handleChangePagination}
          onEdit={this.handleEdit}
          onAnular={this.handleAnular}
          onAprobar={this.handleAprobar}
          onView={this.handleView}
          onVincular={this.handleVincular}

        />

        <FormModal
          visible={this.state.visible}
          formValues={this.state.formValues}
          onAgregarDetalle={this.handleAgregarDetalle}
          onAgregarItem={this.handleAgregarItem}
          onRemoverProducto={this.handleRemoverProducto}
          onRemoverReferencia={this.handleRemoverReferencia}
          onEditarNombreProducto={this.handleEditarNombreProducto}
          onChangeTab={this.handleChangeTab}
          onChange={this.handleChangeForm}
          onClose={() => this.setState({ visible: false })}
          onSave={this.handleSave}
          onScanerProduct={this.handleScanerProduct}
          onBuscarProveedor={this.handleBuscarProveedor}
        />

        <ViewModal
          visible={this.state.viewVisible}
          formValues={this.state.viewFormValues}
          onClose={() => this.setState({ viewVisible: false })}
        />

        <BuscarProductoModal
          visible={this.state.searchProductVisible}
          formValues={this.state.searchProductFormValues}
          title={this.state.formValues.idTipo != 1 ? "Búsqueda de Producto" : "Búsqueda de Servicios"}
          onChange={this.handleChangeProductoModal}
          onSearch={this.handleChangeProductoModal}
          onChangeRow={this.handleSelectProduct}
          onCancel={() => this.setState({ searchProductVisible: false })}
        />
        <EditarNombreProductoModal
          visible={this.state.editarNombreProductoVisible}
          formValues={this.state.editarNombreProductoFormValues}
          onClose={() => this.setState({ editarNombreProductoVisible: false })}
          onSave={this.handleSaveEditarNombreProducto}
        />
      </div>
    );
  }
}